import React, { useEffect, useState, useContext } from 'react'
import StockOutListHeader from './StockOutListHeader'
import StockOutListInner from './StockOutListInner'
import StockOutListFooter from './StockOutListFooter'
import { appContext } from '../../../App'
import { getStockOutByID, getStockOutList, deleteStockOut, getStockOutSettings,
  saveStockOutSettings, getWarehouses } from '../StockOutFunctions'

export const stockOutListControllerContext = React.createContext()

function useStockOutListController() {
  const app = useContext(appContext)
  const [warehouses, setWarehouses] = useState(null)
  const [warehouse, setWarehouse] = useState(null)
  const [recordPerPage, setRecordPerPage] = useState(0)
  const [recPP, setRecPP] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [stockOutList, setStockOutList] = useState([])
  const [stockOutSettings, setStockOutSettings] = useState(null)

  // Filters
  const [searchInputFilter, setSearchInputFilter] = useState({ search_input: '' })
 // const [filter, setFilter] = useState({ sort_by: { date_time_created: -1 }})
  const [filter, setFilter] = useState({})

  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [stockOutListSorted, setStockOutListSorted] = useState(false)
  const [sortBy, setSortBy] = useState(null)
  const [foundUnpostedSO, setFoundUnpostedSO] = useState(null)
  const [selectAll, setSelectAll] = useState(null)
  const [selectedSOId, setSelectedSOId] = useState([])

  const getTotalRecords = () => stockOutList.length

  const updateSOSettings = async (date, footer) => {
    if (footer.record_per_page === '' || footer.record_per_page === 0) {
      footer.record_per_page = 25 // If record_per_page is invalid then set it 25 as default
    }

    const so_settings = await saveStockOutSettings(app, { date, footer })
    if (so_settings) {
      setFilter({ ...filter, date: date })
      setStockOutSettings({ date, footer })
      setRecordPerPage(footer.record_per_page)
      setRecPP(footer.record_per_page)
    } else return so_settings // save settings is not successful
  }

  const sortStockOutListBy = (column) => {
    const sortByDateTimeCreated = () => {
      stockOutList.sort((a, b) => {
        let sorted
        if (!stockOutListSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortByDateReleased = () => {
      stockOutList.sort((a, b) => {
        let sorted
        if (!stockOutListSorted)
          sorted = ((new Date(a.date_released).getTime()) - (new Date(b.date_released).getTime()))
        else
          sorted = ((new Date(b.date_released).getTime()) - (new Date(a.date_released).getTime()))
        return sorted
      })
    }

    const sortByStockOutID = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a._id.toLowerCase()
          y = b._id.toLowerCase()
        } else {
          x = b._id.toLowerCase()
          y = a._id.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortBySourceWarehouse = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.source_warehouse.name.toLowerCase()
          y = b.source_warehouse.name.toLowerCase()
        } else {
          x = b.source_warehouse.name.toLowerCase()
          y = a.source_warehouse.name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByDestWarehouse = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.dest_warehouse.name.toLowerCase()
          y = b.dest_warehouse.name.toLowerCase()
        } else {
          x = b.dest_warehouse.name.toLowerCase()
          y = a.dest_warehouse.name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByPreparedBy = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.prepared_by.toLowerCase()
          y = b.prepared_by.toLowerCase()
        } else {
          x = b.prepared_by.toLowerCase()
          y = a.prepared_by.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReferenceCode = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.reference_code.toLowerCase()
          y = b.reference_code.toLowerCase()
        } else {
          x = b.reference_code.toLowerCase()
          y = a.reference_code.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByRemarks = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.remarks.toLowerCase()
          y = b.remarks.toLowerCase()
        } else {
          x = b.remarks.toLowerCase()
          y = a.remarks.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByStatus = () => {
      stockOutList.sort((a, b) => {
        let x, y
        if (!stockOutListSorted) {
          x = a.status.toLowerCase()
          y = b.status.toLowerCase()
        } else {
          x = b.status.toLowerCase()
          y = a.status.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    switch (column) {
      case 'date_time_created': sortByDateTimeCreated()
        break
      case 'date_released': sortByDateReleased()
        break
      case 'stockout_id': sortByStockOutID()
        break
      case 'source_warehouse': sortBySourceWarehouse()
        break
      case 'dest_warehouse': sortByDestWarehouse()
        break
      case 'prepared_by': sortByPreparedBy()
        break
      case 'reference_code': sortByReferenceCode()
        break
      case 'remarks': sortByRemarks()
        break
      case 'status': sortByStatus()
        break
      default:
    }

    setStockOutListSorted(!stockOutListSorted)
    setStockOutList(stockOutList)
  }

  const filterStockOutList = async (searchString) => {
    const stockout_list = await getStockOutList(app, filter)
    let tempStockOutList = []

    // Create products item_full_description element on productsCopy object on-the-fly
    if (warehouse._id !==0 ) {
      stockout_list.filter(so => so.source_warehouse.id === warehouse._id).forEach((stockout_item, i) => {
        stockout_item.item_full_description = `${stockout_item._id} ${stockout_item.source_warehouse.name} ${stockout_item.dest_warehouse.name} ${stockout_item.prepared_by} ${stockout_item.reference_code} ${stockout_item.remarks} ${stockout_item.status}`
      })

      stockout_list.filter(so => so.source_warehouse.id === warehouse._id).forEach(stockout_item => {
        let found = true
        searchString.split(' ').forEach((search_string_item, i) => {
          found = (found && (stockout_item.item_full_description.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
        })
        if (found) tempStockOutList.push(stockout_item)
      })
    } else {
      stockout_list.forEach((stockout_item, i) => {
        stockout_item.item_full_description = `${stockout_item._id} ${stockout_item.source_warehouse.name} ${stockout_item.dest_warehouse.name} ${stockout_item.prepared_by} ${stockout_item.reference_code} ${stockout_item.remarks} ${stockout_item.status}`
      })

      stockout_list.forEach(stockout_item => {
        let found = true
        searchString.split(' ').forEach((search_string_item, i) => {
          found = (found && (stockout_item.item_full_description.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
        })
        if (found) tempStockOutList.push(stockout_item)
      })
    }

    setStockOutList(tempStockOutList)

    reloadStockOutList(false)
  }

  const batchDeleteSelectedSO = async () => {
    for (let so_id of selectedSOId) { await deleteStockOut(app, so_id) }

    // Reload/Updte data view
    reloadStockOutList()

    setAllCheck(false)
    setSelectAll(false)

    // Reset the selectedSIId to empty array again
    setSelectedSOId([])
  }

  const setAllCheck = (check) => {
    const soCheckBoxes = document.querySelectorAll('.so-checkbox')
    let tempSOIdList = []

    // Reset the list
    setSelectedSOId([])

    // First checked all checkbox that is not checked
    soCheckBoxes.forEach((checkBox, i) => {
      const soId = checkBox.closest('.so-item').id
      if (check) tempSOIdList.push(soId)
      checkBox.checked = check
    })

    setSelectedSOId(tempSOIdList)
  }

  const addSelectedSOId = (so_id) => {
    setSelectedSOId([...selectedSOId, so_id])
  }

  const removeSelectedSOId = (so_id) => {
    setSelectedSOId(selectedSOId.filter((id) => id !== so_id))
  }

  const reloadStockOutList = async (full=true) => {
    if (full) {
      const stockout_list = await getStockOutList(app, filter)
      if (warehouse?._id) setStockOutList(stockout_list.filter(so => so.warehouse.id === warehouse._id))
      else setStockOutList(stockout_list)
    }

    setAllCheck(false)
    setSelectAll(false)
    setSortBy(null)
    setSelectedSOId([])
    setPage(1)
  }

  useEffect(() => {
    const init = async () => {
      const warehouse_list = await getWarehouses(app)
      setWarehouses([{name: '--All--', _id: 0}, ...warehouse_list])
      setWarehouse({name: '--All--', _id: 0})

      const so_settings = await getStockOutSettings(app)
      setFilter({ ...filter, date: so_settings.date }) 
      setStockOutSettings(so_settings)
      setRecordPerPage(so_settings.footer.record_per_page)
      setRecPP(so_settings.footer.record_per_page)
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => { setAllCheck(selectAll) }, [selectAll])

  useEffect(() => {
    if (warehouse && stockOutSettings) reloadStockOutList()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouse, stockOutSettings])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(getTotalRecords() / recordPerPage))

    // slice stockoutlist
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)

    if (stockOutList) setFoundUnpostedSO( stockOutList.find( so => (so.status === 'Unposted') ) )
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordPerPage, stockOutList, page])

  const obj = {
    stockOutList: stockOutList,
    stockOutSettings: [stockOutSettings, setStockOutSettings],
    sortBy: [sortBy, setSortBy],
    searchInputFilter: [searchInputFilter, setSearchInputFilter],
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    recordPerPage: [recordPerPage, setRecordPerPage],
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    warehouse: [warehouse, setWarehouse],
    selectAll: [selectAll, setSelectAll],
    batchDeleteSelectedSO,
    addSelectedSOId,
    removeSelectedSOId,
    selectedSOId,
    foundUnpostedSO,
    warehouses,
    getTotalRecords,
    totalPage,
    reloadStockOutList,
    saveStockOutSettings,
    sortStockOutListBy,
    filterStockOutList,
    stockOutListSorted,
    getStockOutByID,
    updateSOSettings
  }

  return (obj)
}

function StockOutListController() {
  const stockOutListController = useStockOutListController()
  return (
    <React.Fragment>
      <stockOutListControllerContext.Provider value={stockOutListController}>
        <StockOutListHeader />
        <StockOutListInner />
        <StockOutListFooter />
      </stockOutListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(StockOutListController)